module.exports = __webpack_public_path__ + "static/img/1.a0629724.webp";